import styled from "styled-components";

export const Container = styled.section`
  width: 1440px;
  max-width: 85%;
  margin: 0 auto;
  position: ${({ position }) => position || "unset"};
  top: ${({ top }) => top || "unset"};
`;
